
export enum tipoAcao {
  Consulta = 1,
  Anulacao = 2,
  Substituicao = 3,
  Complementar = 4,
  Cancelamento = 5,
  LiberacaoFretes = 6
}

export interface tipoAcaoCteItem {
  id: number,
  descricao: string
}
export interface requestSelecionarItensGridAcao {
  identificacaoId: number,
  identificador: string,
  selecionado: boolean
}
export interface CTEModel {
  identificador: string,
  id: number,
  filialEmissaoCodigo: string,
  filialEmissaoDescricao: string,
  numCTE: string,
  chaveCTE: string,
  dtEmissao: string,
  qtdeNRT: number,
  qtdeNF: number,
  tomador: string,
  pID: number,
  cepDestino: string,
  lote: string,
  peso: number,
  tipoCteId: number,
  tipoCteDescricao: string,
  tipoFaturamentoDescricao: string,
  tipoProcessamentoId: number,
  tipoProcessamentoDescricao: string,
  tipoStatusCancelamentoId: number,
  tipoStatusCancelamentoDescricao: string,
  flagCteAgrupado: boolean,
  valorFrete: number,
  adValorem: number,
  gris: number,
  imposto: number,
  totalFrete: number,
  statusId: number,
  statusDescricao: string,
  clienteId: number,
  clienteNome: string,
  clienteRazaoSocial: string,
  recalculoFrete_AliqICMS: string,
  recalculoFrete_DiferencaFreteTotal: string,
  recalculoFrete_FretePeso: string,
  recalculoFrete_FreteTotal: string,
  recalculoFrete_ValorADVALOREM: string,
  recalculoFrete_ValorGris: string,
  recalculoFrete_ValorICMS: string,
  totalCount: number;
}

export interface uploadTemplateOutput {
  uploadTemplateId: number,
  identificador: string,
  dataUpload: Date,
  usuario: string,
  tipoAcaoId: tipoAcao,
  nomeArquivo: string
}
export interface gerarLotesRequest {
  identificador: string;
  porCliente: boolean;
}

export interface sugestaoLotesResponse {
  loteGeral: any,
  lotesPorCliente: any
}
export interface preLoteCards {
  sessaoId: number,
  title: string,
  quantidade: number,
  totalFrete: number,
  cards: any
}

export interface preLoteDetails {
  totalLote?: number,
  preLoteId: number,
  loteId?: number,
  identificador: string,
  tipoAcaoId: tipoAcao,
  tipoAcaoDescricao: string,
  usuario: string,
  dataInclusao: Date,
  nomeArquivo: string,
  bFinalizado: boolean,
  preLoteStatusId: number,
  descricaoStatus: string
  permiteRecalculo: boolean;
  controlaReemissao: boolean;
  declaracaoObrigatoria: boolean;
  qtdItens?: number;
}

export interface loteDetails {
  totalLote?: number,
  preLoteId: number,
  loteId?: number,
  identificador: string,
  tipoAcaoId: tipoAcao,
  tipoAcaoDescricao: string,
  usuario: string,
  dataInclusao: Date,
  nomeArquivo: string,
  bFinalizado: boolean,
  preLoteStatusId: number,
  descricaoStatus: string
  permiteRecalculo: boolean;
  controlaReemissao: boolean;
  declaracaoObrigatoria: boolean;
  qtdItens?: number;
}

export interface sessaoCardGestaoPreLotes {
  sessaoId: number,
  title: string,
  quantidade: number,
  totalFrete: number,
  cards: cardGestaoPreLotes[]
}

export interface cardGestaoPreLotes {
  id: number,
  selecionado: boolean,
  title: string,
  quantidade: number,
  totalFrete: number
}
